import { useEffect } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import { withRouter } from "../../shared/utility";
import EmptyModal from "../../components/modals/EmptyModal";
import { useParams } from "react-router-dom";
import { LabSampleViewModel } from "../../viewmodels/labSamples/LabSampleViewModel";
import LabSampleForm from "../../components/forms/labSample/LabSampleForm";
import AuditActionLink from "../../components/audit/AuditActionLink";
import FormSectionLoadingSkeleton from "../../components/operational/FormSectionLoadingSkeleton";

function LabSampleFormView(props) {
  const { addSnackbar, logout } = props;
  const { id } = useParams();

  const {
    emptyModal,
    setEmptyModelOpen,
    loading,
    labSample,
    labs,
    inProgress,
    isEdit,
    getLabSampleDetails,
    getLabsForDropdown,
    createLabSample,
    updateLabSample,
  } = LabSampleViewModel(logout, addSnackbar, id);

  useEffect(() => {
    getLabsForDropdown();
    if (id) {
      getLabSampleDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:flex sm:items-center justify-between gap-3 px-4 py-5 sm:px-4 card-custom">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold leading-6 text-gray-900">
              {isEdit ? `Edit Lab Sample #${id}` : "Create Lab Sample"}
            </h1>
          </div>
          {isEdit ? (
            <AuditActionLink
              slug="lab-sample"
              id={id}
              name={labSample?.lot_number}
            />
          ) : null}
        </div>

        <div className="mt-6">
          {loading ? (
            <div className="card-custom p-4">
              <FormSectionLoadingSkeleton rows={6} />
            </div>
          ) : (
            <>
            <LabSampleForm
              inProgress={inProgress}
              labs={labs}
              labSample={labSample}
              isEdit={isEdit}
              createLabSample={createLabSample}
              updateLabSample={updateLabSample}
            />
            </>
          )}
        </div>
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
        size={emptyModal.size}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LabSampleFormView)
);
